enum MODALS {
  ATTACHMENT_RENAME = 'AttachmentRenameModal',
  ADMIN_CLAUSE = 'AdminClauseModal',
  ADMIN_CREATE_EVAL_CONFIG = 'AdminCreateEvalConfigModal',
  ADMIN_CREATE_TEMPLATE = 'AdminCreateTemplateModal',
  ADMIN_TAG = 'TagModal',
  ADMIN_USER = 'UserModal',
  TEAM_FORM = 'TeamFormModal',
  ADMIN_USER_RESEND_INVITE = 'UserResendInviteModal',
  CREATE_ENDORSEMENT = 'EndorsementModal',
  CONFIRM_DELETE = 'ConfirmBlockDeleteModal',
  CONFIRM_BULK_DELETE_BLOCKS = 'ConfirmBulkDeleteBlocksModal',
  CONFIRM_STATUS_FINAL = 'FinalStatusModal',
  CONFIRM_STATUS_FIRM_ORDER = 'ConfirmStatusFirmOrderModal',
  CONFIRM_STATUS_FINAL_BRANDING = 'FinalStatusModalBranding',
  BLOCK_VISIBILITY_MODAL = 'BlockVisibilityModal',
  BLOCK_VISIBILITY_WARNING_MODAL = 'BlockVisibilityWarningModal',
  UPLOAD_IMAGE = 'UploadImageModal',
  CREATE_BRANDING = 'CreateBrandingModal',
  CONTACT_SUPPORT = 'ContactSupportModal',
  COPY_LINK = 'CopyLinkModal',
  CREATE_RENEWAL = 'CreateRenewalModal',
  REPLACE_BASE_TEMPLATE = 'ReplaceBaseTemplateModal',
  CREATE_LIBRARY_BLOCK = 'CreateLibraryBlockModal',
  CREATE_ENTITY = 'CreateEntityButtonModal',
  CLONE_ENDORSEMENT = 'CloneEndorsementModal',
  CLONE_ENDORSEMENT_OPEN_SEARCH = 'CloneEndorsementModalOpenSearch',
  SAVE_VIEW = 'SaveViewModal',
  REMOVE_VIEW = 'RemoveViewModal',
}

export default MODALS;
